<template>
  <div>
    <div class="main3-box">
      <img :src="this.imgPath" id="img" class="img" />
      <div class="box-title">
        <router-link
          :to="{
            path: '/newsdetailed/',
            query: { id: `${this.one.resourceId}` },
          }"
          class="box-title"
        >
          <div class="date">
            <div class="p">
              <p>{{ this.one.createTime.slice(8, 10) }}</p>
              <p>{{ this.one.createTime.slice(0, 7) }}</p>
              <p></p>
            </div>
          </div>
          <div class="box-text">
            <p>
              {{ this.one.title }}
            </p>
            <p>
              {{ this.one.content.replace(this.regex, "") }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
    <div class="main3-right">
      <div v-for="person in newarr" :key="person.resourceId">
        <router-link
          :to="{
            path: '/newsdetailed/',
            query: { id: `${person.resourceId}` },
          }"
          class="box-title"
        >
          <div class="date">
            <div class="p">
              <p>{{ person.createTime.slice(8, 10) }}</p>
              <p>{{ person.createTime.slice(0, 7) }}</p>
              <p></p>
            </div>
          </div>
          <div class="box-text">
            <p>
              {{ person.title }}
            </p>
            <p>
              {{ person.content }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "news",
  data() {
    return {
      category: "",
      type: 1,
      status: 1,
      one: [],
      //去除p标签
      regex: /(<([^>]+)>)/gi,
      newarr: [],
      imgPath: "",
    };
  },

  watch: {
    category: function (newVal, oldVal) {},
  },
  mounted() {
    this.prt();
  },
  methods: {
    prt() {
      this.category = this.$route.query.category;

      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 5,
            category: this.category,
          },
        })
        .then((res) => {
          console.log(res);
          // res.data.data[0].content = this.getSimpleText(res.data.data[0])
          this.one = res.data.data[0];
          this.one.content = this.getSimpleText(res.data.data[0].content);
          this.imgPath = res.data.data[0].imgPath;
          // document.getElementsByClassName('img').style.background='url(`res.data.data[0].imgPath`) #fff no-repeat left center';
          // document.getElementsByClassName('img').style.background = "url('" + res.data.data[0].imgPath + " ') no-repeat 0 center"  ;
          this.newarr = res.data.data.slice(1);

          for (var i = 0; i < this.newarr.length; i++) {
            this.newarr[i].content = this.getSimpleText(this.newarr[i].content);
          }
        });
    },
    sliceDay(arr) {
      return arr.slice(8, 10);
    },
    sliceYear(arr) {
      return arr.slice(0, 7);
    },
    delHtmlTag(str) {
      console.log("!!@!#!");
      return str.replace(/<[^>]+>/g, ""); //正则去掉所有的html标记
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”",
      };
      return html
        .replace(re1, "")
        .replace(
          /&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi,
          function (all, t) {
            return arrEntities[t];
          }
        );
    },
  },
};
</script>
<style scoped>
.dimg1 {
  width: 679px;
  height: 414px;
}
.main3 .main3-box {
  width: 679px;
  height: 414px;
  position: absolute;
  left: 0rem;
  top: 370px;
  background: #ffffff;
}
.main3 .main3-box .img {
  width: 100%;
  height: 100%;
}
.main3 .box-title {
  display: flex;
  width: 100%;
  align-items: center;
  background-color: white;
  overflow: hidden;
  box-shadow: 0rem 0.96px 9.984px 0rem rgba(176, 183, 213, 0.2);
}
.main3 .box-title .date {
  height: 138px;
  border-right: 1.92px solid #ecf0f2;
}
.main3 .box-title .p {
  margin: 40px 0px 0px 30px;
  width: 107px;
}
.main3 .box-title .p p:nth-child(1) {
  font-size: 29px;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 34px;
  letter-spacing: 1.92px;
}
.main3 .box-title .p p:nth-child(2) {
  margin-top: 6px;
  font-size: 15.936px;
  font-weight: bold;
  color: rgba(29, 29, 29, 0.22);
  line-height: 19.2px;
}
.main3 .box-title .p p:nth-child(3) {
  margin-top: 6px;
  width: 17px;
  height: 2px;
  background: #ffa200;
}
.main3 .box-text {
  margin-left: 33px;
  width: 409.9968px;
  height: 138px;
  /* White-space:nowrap; */
}

.main3 .box-text p:nth-child(1) {
  display: block;
  width: 280px;
  height: 20px;
  margin-top: 44px;
  font-size: 15px;
  font-weight: 400;
  color: #1d1e20;
  letter-spacing: 1x;
  overflow: hidden;
}
.main3 .box-text p:nth-child(2) {
  display: block;
  width: 700px;
  height: 32px;
  line-height: 32px;
  margin-top: 26px;
  font-size: 22px;
  font-weight: 400;
  overflow: hidden;
  color: rgba(29, 29, 29, 0.44);
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
}

.main3-right {
  /* background-color: rgba(0,0,0,0.5); */
  position: absolute;
  top: 295px;
  left: 700.0064px;
  width: 559px;
}
.main3-right .box-title {
  margin-bottom: 25.9968px;
  box-shadow: 0rem 0.96px 9.984px 0rem rgba(176, 183, 213, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue